/*
 * Purpose : Header Main Page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, { Component } from "react";

import Aux from "./../../hoc/Auxilliary/Auxilliary";
import AppBar from "../UI/appBar/appBar";
export default class Header extends Component {
  render() {
    return (
      <Aux>
        <AppBar login={this.props.username} />
        {/* {this.props.username ? <div className={Classes.UserInfo}><b>Logged in user: {this.props.username}</b></div> : ''} */}
      </Aux>
    );
  }
}
//export default Header;
